import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface ThemeStore {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: 'light',
      toggleTheme: () => {
        const currentTheme = get().theme;
        const newTheme = currentTheme === 'light' ? 'dark' : 'light';
        set({ theme: newTheme });
        // Apply theme class to document
        document.documentElement.className = newTheme;
      },
      setTheme: (theme) => {
        set({ theme });
        document.documentElement.className = theme;
      },
    }),
    {
      name: 'bookrum-theme-storage',
    }
  )
);